import * as React from "react";

export type SandboxContext = {
    /**
     * A method to call to log information.
     */
    log: (message: string, ...args: Array<any>) => void;
    /**
     * This is true when we are in a sandboxed fixture or story.
     */
    isInFixture: boolean;
    /**
     * This provides a unique identifier for the specific context.
     *
     * It will always have the same value based on the value of `isInFixture`.
     * When `isInFixture` is `false`, it will be the empty string;
     * when `isInFixture` is `true`, it will be a unique ID.
     *
     * This is useful if you want to isolate cached data or other things when
     * inside a fixture or story.
     */
    uniqueId: string;
};

const context: React.Context<SandboxContext> =
    React.createContext<SandboxContext>({
        isInFixture: false,
        log: (message, ...args) => {
            /* NOOP if we're not in the sandbox */
        },
        uniqueId: "",
    });
context.displayName = "SandboxContext";

export default context;
